import React, { Component } from 'react';
import { Switch, NavLink } from "react-router-dom";

import { AuthConsumer } from "../../context/AuthContext";
import ProtectedRoute from '../ProtectedRoute.js';
import TrainingMain from './TrainingMain';
import TrainingByEmployer from './TrainingByEmployer';
import Employers from './Employers';
//import EmployerTrainees from './EmployerTrainees';

import TrainingProviders from './TrainingProviders';
import Employer from './Employer';
import TrainingProvider from './TrainingProvider';

import User from '../User';

import withStyles from '@mui/styles/withStyles';
import TrainingProvManage from './TrainingProvManage';
import CreditHistory from './CreditHistory';
//import IpayForm from './IpayForm';
import EMarket from './EMarket';

import TrainingHist from './TrainingHist';
import TrainingHistDetails from './TrainingHistDetails';
import EmployerAdmin from './EmployerAdmin';
import EmployerTraining from './EmployerTraining';
import TrainingProvAttendees from './TrainingProvAttendess';

import UserCertificateDetails from './UserCertificateDetails';
import DownloadUserCertificate from './DownloadUserCertificate';

const styles = theme => ({
    subNavBar: {
        backgroundColor: "#00529b",
    }
});

class Dashboard extends Component {
    render() {
        const { path } = this.props.match;
        const { classes } = this.props;

        return (
            <div>
                  <AuthConsumer>
                    {({  user }) =>
                    (
                     <div id="sub-navbar" className={classes.subNavBar}>
                        <NavLink to={`${path}/user/`  + user.username} activeClassName="active-tab" className="sub-navlink">Account</NavLink>
                        <NavLink to={`${path}`} activeClassName="active-tab" className="sub-navlink" exact>My Training</NavLink>
                        <NavLink to={`${path}/trainingHistory/` + user.username} activeClassName="active-tab" className="sub-navlink">Training History</NavLink>
                        <NavLink to={`${path}/creditHistory/user/`  + user.username} activeClassName="active-tab" className="sub-navlink">Purchase History</NavLink>
                        <NavLink to={`${path}/employers/`  + user.username} activeClassName="active-tab" className="sub-navlink">For Employers</NavLink>
                        <NavLink to={`${path}/trainingProviders/`  + user.username} activeClassName="active-tab" className="sub-navlink">For Training Providers</NavLink>
                     </div>
                    )  
                }
                </AuthConsumer>
                <div>
                  
                    <Switch>
                        <ProtectedRoute path={`${path}/trainingMain`} component={TrainingMain} />
                        <ProtectedRoute path={`${path}`} exact component={TrainingMain} />

                        <ProtectedRoute path={`${path}/trainingHistory/details`} component={TrainingHistDetails} from="dashboard"/>
                        <ProtectedRoute path={`${path}/trainingHistory/:username`} component={TrainingHist} from="dashboard"/>

                        <ProtectedRoute path={`${path}/trainingByEmployer`} component={TrainingByEmployer} />

                        <ProtectedRoute path={`${path}/user/:id/addCredit`}  component={EMarket} user/>
                        <ProtectedRoute path={`${path}/user/:id`}  component={User} />

                        <ProtectedRoute path={`${path}/employers/:username`}  component={Employers} />
                        <ProtectedRoute path={`${path}/employer/contacts/:id`} component={EmployerAdmin} />
                        
                        <ProtectedRoute path={`${path}/employer/edit/:id`} component={Employer} />
                        {/* <ProtectedRoute path={`${path}/employer/contacts/:id`} component={Employer} /> */}
                        <ProtectedRoute path={`${path}/employer/trainee/:id`} component={EmployerTraining} />
                        <ProtectedRoute path={`${path}/employer/new/:username`} component={Employer} />
                        <ProtectedRoute path={`${path}/employer/:id/addCredit`} component={EMarket} employer/>
                        <ProtectedRoute path={`${path}/employer/:id`} component={Employer} />
                        

                        <ProtectedRoute path={`${path}/trainingProviders/:username`}  component={TrainingProviders} />

                        <ProtectedRoute path={`${path}/trainingProvider/edit/:id`} component={TrainingProvider} />
                        <ProtectedRoute path={`${path}/trainingProvider/members/:id`} component={TrainingProvider} />
                        <ProtectedRoute path={`${path}/trainingProvider/new/:username`} component={TrainingProvider} />
                        <ProtectedRoute path={`${path}/trainingProvider/manageClasses/attendess/:id`} component={TrainingProvAttendees} />
                        <ProtectedRoute path={`${path}/trainingProvider/manageClasses/:id`} component={TrainingProvManage} />
                        
                        <ProtectedRoute path={`${path}/trainingProvider/:id`} component={TrainingProvider} />
                        <ProtectedRoute path={`${path}/creditHistory/:type/:id`} component={CreditHistory} />

                        <ProtectedRoute path={`${path}/userCertificateRequest/:id`} component={UserCertificateDetails} />

                        <ProtectedRoute path={`${path}/downloadUserCertificate/:id`} component={DownloadUserCertificate} />

                    </Switch>
                </div>
               
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Dashboard);
